<template>
  <div>
    <v-banner>
      <h2 class="font-weight-black primary--text">CEK DATA CALON VOLUNTEER</h2>
    </v-banner>

    <div class="my-5 pb-12">
      <v-row>
        <v-col cols="11">
          <v-text-field
            v-model="value_cari"
            label="Cek Data"
            placeholder="Masukan NIK Atau Nama"
            prepend-inner-icon="mdi-magnify"
            solo
          ></v-text-field>
        </v-col>

        <v-col cols="1" class="mt-2">
          <v-btn color="primary" block @click="cari()"> Cari </v-btn>
        </v-col>
      </v-row>

      <v-row v-if="data.length > 0">
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :search="search"
            :items="data"
            :loading="loading"
          >
            <template v-slot:[`item.nomor`]="{ item }">
              {{
                data
                  .map(function (x) {
                    return x.vol_id;
                  })
                  .indexOf(item.vol_id) + 1
              }}
            </template>
            <template v-slot:[`item.vol_status`]="{ item }">
              <v-icon color="success" size="35" v-if="item.vol_status == 'ya'">
                mdi-check-decagram
              </v-icon>
              <v-icon color="error" size="35" v-else>
                mdi-close-octagon
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import Cookie from "@/helper/cookie.js";

export default {
  data: () => ({
    session: "",
    search: "",
    loading: true,

    value_cari: "",

    data: [],

    headers: [
      {
        text: "No",
        value: "nomor",
        width: "50px",
        align: "center",
        sortable: false,
      },
      { text: "NIK", align: "start", value: "vol_nik" },
      { text: "Nama", align: "start", value: "vol_nama" },
      { text: "Kecamatan", align: "start", value: "kec_nama" },
      { text: "Kelurahan", align: "start", value: "kel_nama" },
      { text: "TPS", align: "start", value: "tps_nama" },
      {
        text: "Volunteer",
        align: "center",
        value: "vol_status",
        sortable: false,
      },
    ],
  }),

  async mounted() {
    this.session = await JSON.parse(Cookie.dec(Cookie.get("myCookie")));
  },

  methods: {
    getData() {
      this.axios
        .get(process.env.VUE_APP_API + "kecamatan", {
          headers: {
            Authorization: "Bearer " + this.session.token,
          },
        })
        .then((res) => {
          this.kecamatan = res.data.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error.response.status);
        });
    },

    cari() {
      this.btnLoading = false;

      const data = {
        value_cari: this.value_cari,
      };

      const url = process.env.VUE_APP_API + "cari";
      this.axios
        .post(url, data, {
          headers: {
            Authorization: "Bearer " + this.session.token,
          },
        })
        .then((response) => {
          this.data = response.data.data;
          this.loading = false;
          this.btnLoading = true;
        })
        .catch((error) => {
          console.log(error.response.status);
          this.btnLoading = true;
        });
    },

    detail(value) {
      this.$router.push("/tps/kecamatan?id=" + value.kec_id).catch(() => {});
    },
  },
};
</script>
